import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";
import { VehicleNotesBus } from "./VehicleNotesBus";

export class VehicleBus extends BaseBus {
    constructor(busObj: VehicleBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.dateInService = DateFunctions.getDate(this.dateInService);
        this.plateExpiration = DateFunctions.getDate(this.plateExpiration);
        this.transExpiration = DateFunctions.getDate(this.transExpiration);
        this.inspectionExpirationDate = DateFunctions.getDate(this.inspectionExpirationDate);
        this.leaseContractExpirationDate = DateFunctions.getDate(this.leaseContractExpirationDate);
        this.insuranceExpiration = DateFunctions.getDate(this.insuranceExpiration);
    }

    CID(): any {
        return this.vehicleId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.co = 1;
    }
    public setFromForm(busObj: any) {
        super.setFromForm(busObj);
        this.isLeased = busObj.isLeasedRadio === "1" ? true : false;
    }
    //public setFromForm(busObj: any) {
    //    this.vehicleId = busObj.vehicleId;
    //    this.vehicleName = busObj.vehicleName;
    //    this.personId = busObj.personId;
    //    this.inventoryLocationId = busObj.inventoryLocationId;
    //    this.insertDt = new Date();
    //    this.updateDt = this.insertDt;
    //    this.isActive = busObj.isActive;
    //    this.notes = busObj.notes;
    //    this.vehImg = busObj.vehImg;
    //    this.nextOilChngMileage = busObj.nextOilChngMileage;
    //    this.dateInService = busObj.dateInService;
    //    this.insertUserId = busObj.insertUserId;
    //    this.updateUserId = busObj.updateUserId;
    //    this.companyId = busObj.companyId;
    //    this.autoVehicleId = busObj.autoVehicleId;
    //    this.vin = busObj.vin;
    //    this.gpsTransponderNumber = busObj.gpsTransponderNumber;
    //    this.co = busObj.co;
    //    this.state = busObj.state;
    //    this.licensePlate = busObj.licensePlate;
    //    this.plateExpiration = busObj.plateExpiration;
    //    this.transponderType = busObj.transponderType;
    //    this.transponderNumber = busObj.transponderNumber;
    //    this.transExpiration = busObj.transExpiration;
    //    this.attachmentDetailFullName = busObj.attachmentDetailFullName;
    //    this.constructionVehicleTradeType = busObj.constructionVehicleTradeType ? busObj.constructionVehicleTradeType.value : '';
    //    this.vehicleType = busObj.vehicleType ? busObj.vehicleType.value : '';
    //    this.regulatedType = busObj.regulatedType ? busObj.regulatedType.value : '';
    //    this.year = busObj.year;
    //    this.make = busObj.make;
    //    this.model = busObj.model;
    //    this.inspectionExpirationDate = busObj.inspectionExpirationDate;
    //    this.isLeased = busObj.isLeased == '1';
    //    this.leasingCompanyNameUnitNbr = busObj.leasingCompanyNameUnitNbr;
    //    this.leasedContractTerm = busObj.leasedContractTerm;
    //    this.leaseContractExpirationDate = busObj.leaseContractExpirationDate;
    //    this.leaseMonthlyPayment = busObj.leaseMonthlyPayment;
    //    this.leaseRemainingBookValue = busObj.leaseRemainingBookValue;
    //    this.hasLadderRack = busObj.hasLadderRack;
    //    this.hasTrailerHitch = busObj.hasTrailerHitch;
    //    this.gvwr = busObj.gvwr;
    //    this.tireSize = busObj.tireSize;
    //    this.personName = busObj.personName;

    //}

    setBeforeSave() {
        super.setBeforeSave();
        this.dateInService = DateFunctions.getDateWithUTCOffset(this.dateInService);
        this.plateExpiration = DateFunctions.getDateWithUTCOffset(this.plateExpiration);
        this.transExpiration = DateFunctions.getDateWithUTCOffset(this.transExpiration);
        this.inspectionExpirationDate = DateFunctions.getDateWithUTCOffset(this.inspectionExpirationDate);
        this.leaseContractExpirationDate = DateFunctions.getDateWithUTCOffset(this.leaseContractExpirationDate);
        this.insuranceExpiration = DateFunctions.getDateWithUTCOffset(this.insuranceExpiration);

    }

    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
        this.companyId = companyId;
    }

    //isValid(): boolean {
    //    return DateFunctions.isValidDate(this.creditDate)
    //        && CommonFunctions.hasGuidValue(this.supplierId)
    //        && CommonFunctions.hasStringValue(this.refNo)
    //        && CommonFunctions.hasGuidValue(this.vendorCreditStatusId)
    //        ? true : false;
    //}
    vehicleId: any;
    vehicleName: string;
    personId: any;
    inventoryLocationId: any;
    vehicleStatusId: any;
    assignedBranchId: any;
    purchasePrice: any;
    isActive: boolean
    notes: string;
    vehImg: any;
    vehImgExt: string;
    nextOilChngMileage: number;
    dateInService: Date;
    companyId: any;
    autoVehicleId: number;
    vin: string;
    gpsTransponderNumber: string;
    co: number;
    state: string;
    licensePlate: string;
    plateExpiration: Date;
    transponderType: string;
    transponderNumber: string;
    transExpiration: Date;
    attachmentDetailFullName: string;
    personName: string;
    constructionVehicleTradeType: string;
    vehicleType: string;
    regulatedType: string;
    vehiclePowerTrainTypeId: string;
    year: number;
    make: string;
    model: string;
    inspectionExpirationDate: Date;
    isLeased: boolean;
    leasingCompanyNameUnitNbr: string;
    leasedContractTerm: string;
    leaseContractExpirationDate: Date;
    leaseMonthlyPayment: number;
    leaseRemainingBookValue: number;
    hasLadderRack: boolean;
    hasTrailerHitch: boolean;
    gvwr: string;
    tireSize: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    currentMileage: number;
    empNo: string;
    legalName: string;
    costCenterName: string;
    employeeUnionRole: string;
    jobTitle: string;
    employeeManager: string;
    employeeStatus: boolean;
    vehicleNotes: VehicleNotesBus[];
    personalVehicle: boolean;
    vehicleReimbursement: boolean;
    insurancePolicyReceived: boolean;
    insuranceExpiration: Date;

}
